// this is like DPI. 3 = 300 DPI
const SCALE = 3;

export const IMAGE_HEIGHT = 365 * SCALE;
export const IMAGE_WIDTH = 500 * SCALE;
export const TEXT_HEIGHT = 30 * SCALE;
export const TEXT_LINEHEIGHT = TEXT_HEIGHT * 1.75;
export const TEXT_PADDING = 4 * SCALE;
